import { FlagEnvs, LocalizedFlagsEnabledType } from 'sites/types';
import { SUPPORTED_LOCALE } from 'utils/constants';

export type LocalizedFeatureFlags = {
  [env in FlagEnvs]?: {
    [locale in SUPPORTED_LOCALE]?: Record<string, boolean>;
  };
};

export const getLocalizedFlagsEnabled = (
  allLocalesFeatureFlags: LocalizedFeatureFlags
): LocalizedFlagsEnabledType => {
  const result = {};

  for (const env in allLocalesFeatureFlags) {
    const allLocales = allLocalesFeatureFlags[env];

    for (const locale in allLocales) {
      const allFlags = allLocales[locale];

      for (const flag in allFlags) {
        if (allFlags[flag]) {
          if (!result[flag]) {
            result[flag] = {};
          }

          if (!result[flag][env]) {
            result[flag][env] = [];
          }

          result[flag][env].push(locale);
        }
      }
    }
  }

  return result;
};
